var table_viewer_default = {
  "viewMode": "yinfi",
  "editMode": "smutb",
  "container": "QhnHV",
  "cell": "uv2AN"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
